















































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
    components: {

    }
}) export default class ServiceCenterQuestion extends Mixins(VueHoduCommon) {

    title : string = "";
    content : string = "";
    name : string = "";
    email : string = "";
    phone_number : string = "";

    beforeCreate() : void {
        document.title = '도입 및 기타 문의 | 고객센터';
    }

    mounted() : void {

    }

    /**
     * 취소
     */
    cancel() : void {
        this.title = "";
        this.content = "";
        this.name = "";
        this.email = "";
        this.phone_number = "";
    }

    /**
     * 문의사항 보내기
     */
    async sendQuestion() : Promise<void> {
        const vue = this;

        if( this.checkValid() == false ) {
            return;
        }

        await this.hodu_api_call('api/v1/hodu/question', 'post', {
            title : this.title,
            content : this.content,
            name : this.name,
            email : this.email,
            phone_number : this.phone_number,
            os : await this.getOSInfo(),
            browser : (await this.getBrowserInfo()).trim()
        }).then((response) => {
            console.log(response);
            alert("문의사항 등록 완료");
        }).catch((e) => {
            alert("문의사항 등록 실패, 잠시 후 다시 시도해주세요");
        }).finally(() => {
            vue.doSetServiceCenterTab(vue.ServiceCenterTab.QNA);
        });
    }

    /**
     * 값 체크
     */
    checkValid() : boolean {

        // 제목 길이 확인
        if( this.title.length < 1 ) {
            alert("제목을 입력해주세요");
            $('.cs_title').focus();
            return false;
        }

        // 내용 길이 확인
        if( this.content.length < 1 ) {
            alert("내용을 입력해주세요");
            $('.cs_txtarea').focus();
            return false;
        }

        // 이름 길이 확인
        if( this.name.length < 1 ) {
            alert("이름을 입력해주세요");
            $('#cs_name').focus();
            return false;
        }

        // 이메일 길이 확인
        if( this.email.length < 1 ) {
            alert("이메일을 입력해주세요");
            $('#cs_email').focus();
            return false;
        }

        // 이메일 형식 체크
        if(! /\S+@\S+\.\S+/.test(this.email) ){
            alert("이메일 형식을 확인해주세요");
            $('#cs_email').focus();
            return false;
        }

        // 휴대폰 번호가 입력되어있다면 형식 체크
        if( this.phone_number.length > 0 ) {
            
            // 010-1234-5678 형식인 경우
            if( this.phone_number.indexOf('-') > -1 ) {
                if( /^\d{3}-\d{3,4}-\d{4}$/.test(this.phone_number) == false ) {
                    alert("휴대폰 번호 형식을 확인해주세요 예) 010-0000-0000");
                    $('#cs_tel').focus();
                    return false;
                }
            }

            // 01012345678 형식인경우
            else {
                if( /^\d{3}\d{3,4}\d{4}$/.test(this.phone_number) == false ) {
                    alert("휴대폰 번호 형식을 확인해주세요 예) 010-0000-0000");
                    $('#cs_tel').focus();
                    return false;
                }     
            }
        }

        return true;
    }

}

